import type { SVGProps } from 'react';

const SvgPlayFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M6 20.1958C6 20.9812 6.86395 21.46 7.53 21.0438L20.6432 12.848C21.2699 12.4563 21.2699 11.5437 20.6432 11.152L7.53 2.95625C6.86395 2.53997 6 3.01881 6 3.80425V20.1958Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgPlayFilled;
